(ns manage.feed-page.view
  (:require [common.widgets.page :as page]
            [manage.feed-table.view :refer [table]]
            [uix.core :refer [$]]))

(defn feed-page [_]
  ($ page/page
     ($ page/page-header
        {:title "Dynamic feeds"})
     ($ page/content-padding {:sx #js {:overflow "hidden"}}
        ($ table {:feed-type :lookup}))))

